import React from "react";
import Field from "../Common/Field";
import constants from "../../../utils/constants";
export default class Number extends Field {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  onChange(name, value, culture) {
    var culture = culture.replace("-", "");
    var numberFormatRegex = new RegExp(constants.numberPattern[culture].regex);
    const { formikForm } = this.props;

    if (numberFormatRegex.test(value) !== false) {
      formikForm.setFieldValue(name, value);
    }
  }

  renderInput() {
    const {
      formikField,
      isRequired,
      config: { name, placeholder, readOnly, disabled, culture },
    } = this.props;

    return (
      <input
        id={name}
        className="field__input field__input--text"
        type="text"
        placeholder={placeholder}
        readOnly={!!readOnly}
        disabled={!!disabled}
        aria-required={!!isRequired}
        {...formikField}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={(e) => {
          this.onChange(name, e.target.value, culture);
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Number.js